import type {
  MedicationPadAlertError,
  MedicationPadItemType,
} from '@/components/Patient/components/PrescriptionPad/PrescriptionPad.types';
import type { DispenseLimitRow } from '@/utils/dosageLimit/getFormulationDispenseLimitRows';
import { getPadItemDosageSuffix } from '@/utils/dosageLimit/getPadItemDosageSuffix';
import type { PrescriptionPadRules } from '../types';
import { getDosageAlertError } from './validateDosage';
import { getMaxDailyDoseAlertError } from './validateMaxDailyDose';

/**
 * The alert shown on a pad item and blocking review: the dosage problem first, then the maximum daily dose one.
 * @param dispenseLimitRows - the pad's rows as they stand with `item`, derived once per pad by the caller
 */
export const getMedicationPadItemAlertError = (
  item: MedicationPadItemType,
  dispenseLimitRows: DispenseLimitRow[],
  rules: PrescriptionPadRules,
): MedicationPadAlertError =>
  getDosageAlertError(item.medicationPadItem, getPadItemDosageSuffix(item, dispenseLimitRows, rules)) ??
  getMaxDailyDoseAlertError(item, rules);
